import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nav-link-icon d-md-none d-lg-inline-block",
  style: {"vertical-align":"middle"}
}
const _hoisted_2 = {
  class: "nav-link-title",
  style: {"vertical-align":"middle"}
}

import MaterialIcon from "@/shared/components/utils/MaterialIcon.vue";

interface PropsInterface {
  icon?: string;
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NavAppName',
  props: {
    icon: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  icon?: string;
  title: string;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(MaterialIcon, {
            name: props.icon
          }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.title), 1)
  ], 64))
}
}

})